import './_search-drawer.scss';
import component from './search-drawer';

export default component;
